import React from 'react';
import classnames from 'classnames';
import get from 'lodash/get';

import Icon, { GLYPHS } from '../../../common/icon';
import * as shapes from '../../shapes';
import { t } from '../../../../modules/infra/i18n';

const Item = ({ item, selectBarber, unassigned, className }) => {
  const avatarSrc = get(item, 'photos[0].thumbnail');
  const text = unassigned ? t('register:sale.order_info_item.unassigned_sale') : `${item.firstName} ${item.lastName}`;

  return (
    <li className="layout__item">
      <button
        type="button"
        onClick={selectBarber}
        className={classnames(
          'c-register-barber-select',
          { 'c-register-barber-select--unassigned': unassigned,
            'has-avatar': avatarSrc },
          className
        )}
      >
        <span className="c-register-barber-select__avatar">
          <img className="c-avatar" src={avatarSrc} display-if={avatarSrc} alt="" />
        </span>
        {text}
        <span className="c-register-barber-select__icon" display-if={!unassigned}>
          <Icon glyph={GLYPHS.chevronRight} />
        </span>
      </button>
    </li>
  );
};

Item.propTypes = {
  item: shapes.barber,
  selectBarber: shapes.handler.isRequired,
  unassigned: shapes.flag,
  className: shapes.string,
};
Item.defaultProps = {
  item: null,
  unassigned: false,
  className: '',
};

export default Item;